import { Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'

@Component({
   selector: 'app-research',
   standalone: true,
   imports: [RouterOutlet],
   templateUrl: './research.component.html',
   // this host adds a 'contents' class, which more or less hides the element from the CSS hierarchy, making the flex box thing work ¯\_(ツ)_/¯
   // eslint-disable-next-line @angular-eslint/no-host-metadata-property
   host: {
      class: 'contents'
   }
})
export class ResearchComponent {

}
